module.exports = __webpack_public_path__ + "static/img/quote.83fc910c.png";